<template>
  <div>
    <template v-if="state === 'success'">
      <div class="c-panel c-panel--full u-mrgn-bottom--4">
        <div class="c-panel__item">
          <div class="u-mrgn-bottom--5">
            <div class="o-layout">
              <div class="o-layout__item u-1of4">
                <a :href="miUrl" data-no-turbolink="true">
                  <img :src="product.logo_url" width="36px" height="36px" />
                </a>
              </div>
              <div class="o-layout__item u-3of4 u-pad-left--3">
                <div>
                  <a :href="productUrl" data-no-turbolink="true" class="u-txt--small u-txt--bold u-fg--black inline">
                    <EllipsisText :line-num="1" :message="product.name" />
                  </a>
                </div>
                <div class="u-txt--small">
                  <a :href="typeUrl" data-no-turbolink="true" class="u-fg--black">{{ product.type }} </a>
                </div>
              </div>
            </div>
          </div>

          <div class="u-mrgn-bottom--6 u-txt--small">
            <div class="u-fg--ash-dark u-mrgn-bottom--3">{{ navDate }}</div>
            <div class="o-layout">
              <div>
                <div class="o-layout__item u-2of4 u-mrgn-bottom--2">Nilai Aktiva Bersih/Unit</div>
                <div class="o-layout__item u-2of4 u-txt--bold u-align-right u-mrgn-bottom--2">{{ navValue }}</div>
              </div>
              <div>
                <div class="o-layout__item u-2of4 u-mrgn-bottom--2">Perubahan Harga</div>
                <div class="o-layout__item u-2of4 u-txt--bold u-align-right u-mrgn-bottom--2">
                  <RodValue
                    :return-value="product.return_one_day"
                    :last-nav-value="product.last_nav_value"
                    show-money
                  />
                </div>
              </div>
              <div>
                <div class="o-layout__item u-2of4 u-mrgn-bottom--2">Manajer Investasi</div>
                <div class="o-layout__item u-2of4 u-txt--bold u-align-right u-mrgn-bottom--2">
                  {{ product.im_name }}
                </div>
              </div>
              <div>
                <div class="o-layout__item u-2of4 u-mrgn-bottom--2">Prinsip Pengelolaan</div>
                <div v-if="!product.syariah" class="o-layout__item u-2of4 u-txt--bold u-align-right u-mrgn-bottom--2">
                  Konvensional
                </div>
                <div v-else class="o-layout__item u-2of4 u-txt--bold u-align-right u-mrgn-bottom--2">
                  <a href="/bukareksa/reksa-dana-syariah" data-no-turbolink="true">Syariah</a>
                </div>
              </div>
            </div>
          </div>

          <div class="u-mrgn-bottom--6">
            <div :class="sectionClass">Riwayat Keuntungan</div>
            <ReturnHistory :return-title="returnTitle" :return-data="returnData" />
          </div>

          <div class="u-mrgn-bottom--4">
            <div :class="sectionClass">Grafik Perubahan Harga</div>
            <ProductChart :product="product" :show-top-range-selector="true" chart-height="250px" is-mweb />
          </div>

          <div class="u-txt--small u-mrgn-bottom--6">
            Baca <a :href="prospectusUrl" class="u-txt--bold">Prospektus</a> dan
            <a :href="factsheetUrl" class="u-txt--bold">Keterangan Ringkas</a>.
          </div>

          <div class="u-mrgn-bottom--6">
            <div :class="sectionClass">Alokasi Aset ({{ assetAllocationDate }})</div>
            <ul>
              <li v-for="(asset, index) in product.asset_allocation" :key="index">{{ asset }}</li>
            </ul>
          </div>

          <div class="u-mrgn-bottom--6">
            <div :class="sectionClass">Tujuan Investasi</div>
            <p class="u-mrgn-bottom--0">{{ product.investment_goals }}</p>
          </div>

          <button class="c-btn c-btn--red c-btn--block c-btn--large" @click="goToBuyPage()">Beli Sekarang</button>
        </div>
      </div>

      <div><OtherLinkFooter :other-links="otherLinks" /></div>
    </template>
    <template v-if="state === 'error'">
      <div class="o-container o-container--full u-mrgn-top--3 u-txt--medium">
        Gagal memuat data, <a @click="getProduct">muat ulang</a>
      </div>
    </template>
    <template v-if="state === 'loading'">
      <LoadingSpinner is-bg-sand />
    </template>
  </div>
</template>

<script>
import EllipsisText from 'shared/components/Ellipsis/EllipsisText';
import RodValue from 'shared/components/RodValue';
import ProductChart from 'shared/components/ProductChart';
import ReturnHistory from 'shared/components/mweb/ReturnHistory';
import OtherLinkFooter from 'shared/components/mweb/OtherLinkFooter';
import LoadingSpinner from 'shared/components/LoadingSpinner';

export default {
  name: 'ProductDetailMobile',
  components: {
    OtherLinkFooter,
    EllipsisText,
    LoadingSpinner,
    RodValue,
    ReturnHistory,
    ProductChart,
  },
  props: {
    otherLinks: {
      type: Array,
      default: () => [],
    },
    state: {
      type: String,
      default: 'loading',
    },
    product: {
      type: Object,
      default: () => ({}),
    },
    returnTitle: {
      type: Array,
      default: () => [],
    },
    returnData: {
      type: Array,
      default: () => [],
    },
    assetAllocationDate: {
      type: String,
      default: '',
    },
    prospectusUrl: {
      type: String,
      default: '',
    },
    factsheetUrl: {
      type: String,
      default: '',
    },
    typeUrl: {
      type: String,
      default: '',
    },
    miUrl: {
      type: String,
      default: '',
    },
    productUrl: {
      type: String,
      default: '',
    },
    navDate: {
      type: String,
      default: '',
    },
    navValue: {
      type: String,
      default: '',
    },
  },
  computed: {
    sectionClass() {
      return 'u-txt--fair u-mrgn-bottom--3';
    },
  },
  methods: {
    getProduct() {
      this.$emit('getProduct');
    },
    goToBuyPage() {
      this.$emit('goToBuyPage');
    },
  },
};
</script>
